import React from "react";

const Commission = () => {
  return (
    <div className="bg-gradient-to-r from-cyan-100 to-teal-100 rounded-lg shadow-md p-8 flex flex-col md:flex-row items-center gap-8">
      {/* Left content */}
      <div className="flex-1">
        <div className="flex items-center gap-2 mb-3">
          <div className="bg-gradient-to-br from-purple-500 to-pink-500 text-white p-2 rounded-md">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17 20h5V4H2v16h5m10-10H7m10 4H7m0-8h10"
              />
            </svg>
          </div>
          <span className="text-sm font-medium text-gray-700">
            Included in your business plan
          </span>
        </div>

        <h2 className="text-2xl font-bold mb-4">
          Put an end to your payroll struggles
        </h2>

        <p className="text-gray-600 mb-6">
          Make paying your team easy, so you can spend more time on the things
          that matter.
        </p>

        <ul className="space-y-2 text-gray-700 mb-6">
          <li className="flex items-start gap-2">
            <span className="text-green-600 font-bold">✓</span>
            Combine wages, commissions, and tips into a single payment
          </li>
          <li className="flex items-start gap-2">
            <span className="text-green-600 font-bold">✓</span>
            Adjust amounts owed to include bonuses
          </li>
          <li className="flex items-start gap-2">
            <span className="text-green-600 font-bold">✓</span>
            Share detailed earning reports for each team member
          </li>
        </ul>

        <button className="bg-black text-white px-6 py-2 rounded-md hover:bg-gray-800">
          Activate plan
        </button>
      </div>

      {/* Right content (mock payroll preview) */}
      <div className="w-full md:w-64 bg-white rounded-lg shadow-lg p-4">
        <h3 className="text-sm font-semibold mb-3">This week’s pay run</h3>
        <ul className="space-y-2 text-sm">
          <li className="flex justify-between">
            <span>Jessica (Contractor)</span>
            <span>$228</span>
          </li>
          <li className="flex justify-between">
            <span>Lisa (Full time)</span>
            <span>$1560</span>
          </li>
          <li className="flex justify-between">
            <span>Tom (Part-time)</span>
            <span>$788</span>
          </li>
          <li className="flex justify-between">
            <span>Kevin (Full time)</span>
            <span>$900</span>
          </li>
        </ul>

        <div className="mt-4 border-t pt-3">
          <h4 className="text-sm font-medium">Sarah (Full time)</h4>
          <div className="flex justify-between text-xs text-gray-600">
            <span>Wages</span>
            <span>$485</span>
          </div>
          <div className="flex justify-between text-xs text-gray-600">
            <span>Commissions</span>
            <span>$99</span>
          </div>
          <div className="flex justify-between text-xs text-gray-600">
            <span>Tips</span>
            <span>$450</span>
          </div>
          <div className="flex justify-between font-semibold mt-2">
            <span>Total to pay</span>
            <span>$1034</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Commission;
